// extracted by mini-css-extract-plugin
module.exports = {"employeeSelectionPanel":"iXKpm","employeeSelectionPanelCount":"_14V0_","splitter":"_2OY4v","statusModalUser":"_1mGbN","statusModalList":"_32zf2"};